import { render, staticRenderFns } from "./CategoryTypeSelect.vue?vue&type=template&id=47f1da0a"
import script from "./CategoryTypeSelect.vue?vue&type=script&lang=ts"
export * from "./CategoryTypeSelect.vue?vue&type=script&lang=ts"
import style0 from "./CategoryTypeSelect.vue?vue&type=style&index=0&id=47f1da0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports